export default __webpack_public_path__ + "static/media/hidraulic15.58bb05ba.jpg";